<template>
    <div>
        <v-dialog
            v-model="showDialogYesNoIsRequired"
            transition="dialog-top-transition"
            persistent
            width="500"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    Update {{ typeDescription }}
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>{{ typeDescription }} Is Required</label>
                            <v-radio-group 
                                v-model="yesNoIsRequired" 
                                row
                            >
                                <v-radio
                                    label="Yes"
                                    :value="1"
                                    color="var(--color__main)"
                                ></v-radio>
                                <v-radio
                                    label="No"
                                    :value="0"
                                    color="var(--color__main)"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <v-row v-if="isFinanceType && Number(yesNoIsRequired) === 1">
                        <v-col cols="12">
                            <label>Amount</label>
                            <v-text-field
                                v-model="financeAmount"
                                outlined
                                dense
                                v-formatMoney="moneyFormat"
                                :rules="[validations.required]"
                            ></v-text-field>

                            <label>Lender</label>
                            <v-text-field
                                v-model="financeWho"
                                outlined
                                dense
                                :rules="[validations.required]"
                            ></v-text-field>

                            <label>Payment Terms</label>
                            <v-text-field
                                v-model="financePaymentTerms"
                                outlined
                                dense
                                :rules="[validations.required]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonCancel v-btn-large"
							outlined
							@click="cancel"
						>
							Cancel
						</v-btn>

						<v-btn
							class="mx-2 v-btn-large"
							outlined
                            @click="confirm"
						>
							Confirm
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>
	</div>
</template>

<script>

    import Helpers from '@/utilities/Helpers';
    import { required } from "@/utilities/Rules";
    import { formaterDecimalBRServer } from '@/utilities/Utils';

	export default {

        mixins: [Helpers],

        props: {
			
            id: {
                type: Number,
                default: 0
            },
			
            idAux: {
                type: Number,
                default: 0
            },
			
            type: {
                type: String,
                default: ""
            },

            setYesNoIsRequired: {
                default: null
            },

            financeData: {
                default: null
            },

			showDialogYesNoIsRequired: {
				default: false
			},
		},

        watch: {
            async "idAux"() {
				this.loadFinanceValues();
            },
        },
		
        data: () => ({
			
            yesNoIsRequired: null,
            financeAmount: null,
            financeWho: "",
            financePaymentTerms: "",

            moneyFormat: {
                prefix: '$ ',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 2,
            },

            validations: {
                required
            },
		}),

        computed: {

            isFinanceType() {
                return this.type == 'fi';
            },

            typeDescription() {
                if (this.type == 'ts') {
                    return "Technical Specification";
                }
                else if (this.type == 'df') {
                    return "Drafting";
                }
                else if (this.type == 'pm') {
                    return "Permitting";
                }
                else if (this.type == 'se') {
                    return "Send Email For Customer Construction Steps";
                }
                else if (this.type == 'fi') {
                    return "Financing Requirements";
                }
                else if (this.type == 'lc') {
                    return "Load Calculation";
                }
                else {
                    return "";
                }
            },
        },

        methods: {
            loadFinanceValues() {
                console.log('this.financeData', this.financeData);
                if (this.setYesNoIsRequired != null && this.setYesNoIsRequired != undefined) {
                    this.yesNoIsRequired = this.setYesNoIsRequired;
                }

                if (this.financeData != null && this.financeData != undefined) {
                    this.financeAmount = this.financeData.amountFormatted ?? null;
                    this.financeWho = this.financeData.who ?? "";
                    this.financePaymentTerms = this.financeData.paymentTerms ?? "";
                }
            },

            cancel() {
                this.$emit('update:showDialogYesNoIsRequired', false);
            },

            async confirm() {
                
                this.showLoading();

                if (this.type == 'fi' && Number(this.yesNoIsRequired) === 1) {
                    if (!this.financeAmount || !this.financeWho || !this.financePaymentTerms) {
                        this.hideLoading();
                        this.showToast("error", "Warning!", "Amount, Who and Payment Terms are required when Finance is Yes.");
                        return;
                    }
                }

                let result = { success: false };

                if (this.type == 'fi' && Number(this.yesNoIsRequired) === 1) {
                    result = await this.$store.dispatch("serviceModule/SaveServiceFinance", {
                        idService: this.id,
                        amount: formaterDecimalBRServer(this.financeAmount),
                        who: this.financeWho,
                        paymentTerms: this.financePaymentTerms
                    });
                }
                else {
                    const request = {
                        idService: this.id,
                        isRequired: this.yesNoIsRequired,
                        type: this.type
                    }

                    result = await this.$store.dispatch("serviceModule/UpdateYesNoRequired", request);
                }

                if (result.success) {
                    this.showToast("success", "Success!", `${this.typeDescription} requirement updated successfully!`);

                    this.$emit('methodConfirmToCall');
                }
                else {
                    this.showToast("error", "Warning!", result.message || "Unable to update the finance information.");
                }
                this.cancel();

                this.hideLoading();
            }
        }
    };
</script>